import { z } from "zod";
import { IdSchema, listOf, NameSchema } from "./primitives";

/** A named set of perspectives that one delta can address at once. */
export const DistributionListSchema = z.strictObject({
  id: IdSchema,
  name: NameSchema,
  handles: listOf(IdSchema),
});
export type DistributionList = z.infer<typeof DistributionListSchema>;

export const DistributionListOperationSchema = z.discriminatedUnion("type", [
  z.strictObject({
    type: z.literal("distributionList.set"),
    distributionList: DistributionListSchema,
  }),
  z.strictObject({
    type: z.literal("distributionList.update"),
    id: IdSchema,
    changes: z.strictObject({
      name: NameSchema.optional(),
      handles: listOf(IdSchema).optional(),
    }),
  }),
  z.strictObject({
    type: z.literal("distributionList.perspectiveAdded"),
    id: IdSchema,
    handle: IdSchema,
  }),
  z.strictObject({
    type: z.literal("distributionList.perspectiveRemoved"),
    id: IdSchema,
    handle: IdSchema,
  }),
  z.strictObject({ type: z.literal("distributionList.unset"), id: IdSchema }),
]);
export type DistributionListOperation = z.infer<typeof DistributionListOperationSchema>;
